import { useMutation } from 'react-query';
import { post } from 'core/network/RestApi';
import { ConsentRecord, Products } from '../types/complianceTypes';

interface RequestBody {
  identifier: string;
}

interface ResponseBody {
  identifier: string;
  products: Products[];
  expired: boolean;
  history: ConsentRecord[];
}

export const useCheckCanSendMutation = (siteId: string, emailAddress: string) => {
  return useMutation(() => {
    return post<ResponseBody, RequestBody>(`/sites/${siteId}/compliance/check_product_has_compliance_to_send`, {
      identifier: emailAddress,
    });
  });
};
